import PropTypes from 'prop-types'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import { usersAPI } from '../../../../../../proxyConfig/apiUrls'
import { ROLES } from '../../../../../containers/TeamsManagement/constants'
import { useAccessSearchParam } from '../../../../../zustand/authentication/use-auth-store'
import { badgeColorOptions } from '../../../../stories/atoms/badges/constants'
import ListItemComponent from '../../../../stories/molecules/list-items'
import { useGetAvatarQuery } from '../../../../../react-query/avatar/query/use-get-avatar-query'
import { iconSizeOptions } from '../../../../stories/atoms/icons/icons-sizes'
import StatusIndicationComponent from '../../../../stories/atoms/status-indication'
import { statusIndicationMemberVariantOptions } from '../../../../stories/atoms/status-indication/constants'

const handleRoleColor = (role) => {
  switch (role) {
    case ROLES.POWERUSER:
      return badgeColorOptions.VIOLET
    case ROLES.ASSISTANT:
      return badgeColorOptions.BLUE
    case ROLES.EXTERNALVISITOR:
      return badgeColorOptions.TURQUOISE
    case ROLES.SUBCONTRACTOR:
      return badgeColorOptions.OCHRE
    case ROLES.VIEWER:
      return badgeColorOptions.GREEN
    default:
      return badgeColorOptions.OCHRE
  }
}

const MemberItem = ({ item }) => {
  const { formatMessage } = useIntl()
  const accessSearchParam = useAccessSearchParam()
  const profilePicture = `${usersAPI}/${item.userId}/avatar${accessSearchParam()}`
  const { data: cachedAvatarImage } = useGetAvatarQuery(profilePicture)

  return (
    <ListItemComponent.Item
      itemKey={item.userId}
      leadingIcon={
        <StatusIndicationComponent
          image={cachedAvatarImage}
          size={iconSizeOptions['ICON-L']}
          variant={statusIndicationMemberVariantOptions.MEMBER}
          iconNotEnclosed
        />
      }
      title={`${item.firstName} ${item.lastName}`}
      secondaryText={item.email}
      badge={{
        label:
          formatMessage({ id: `personas_roleLabel${item.role}` }) || item.role,
        color: handleRoleColor(item.role)
      }}
      style={{ borderRadius: 0, border: 0 }}
      noPadding
    />
  )
}

MemberItem.propTypes = {
  item: PropTypes.object
}

const MemoizedMemberItem = memo(MemberItem)
MemoizedMemberItem.displayName = 'MemberItem'

export default MemoizedMemberItem
